/**
 * Gera URL de autenticação com parâmetro de redirect
 * Uso: getAuthUrlWithRedirect() → "/auth?redirect=%2Ffavoritos"
 */
export function getAuthUrlWithRedirect(): string {
  const currentPath = window.location.pathname;
  
  // Não redirecionar de volta para /auth ou da home
  if (currentPath === '/auth' || currentPath === '/') {
    return '/auth';
  }
  
  return `/auth?redirect=${encodeURIComponent(currentPath)}`;
}

/**
 * Valida se o redirect é um path interno seguro
 */
export function isValidRedirectPath(path: string | null): boolean {
  if (!path) return false;
  
  // Deve começar com / e não conter protocolo
  return path.startsWith('/') && !path.includes('://');
}
